import { jsx as _jsx } from "react/jsx-runtime";
export default function BottomUpModalContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    children: children
  });
}